import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { FeedbackPage } from "@/features/feedback/FeedbackPage";

const search = z.object({
  tab: z.enum(["results", "testimonials", "referrals", "case-studies"]).optional(),
  stage: z.enum(["all", "new", "requested", "approved", "published", "declined"]).optional(),
});

export const Route = createFileRoute("/_app/feedback")({
  validateSearch: search,
  component: () => <FeedbackPage search={Route.useSearch()} />,
});
